export function formatTreatmentPlanMoney(centavos, currency = "PHP") {
  const symbol = currency === "PHP" ? "₱"
    : currency === "USD" ? "$"
      : currency ? `${currency} ` : "";
  const amount = Math.round((Number(centavos) || 0) / 100);
  return symbol + amount.toLocaleString("en-US");
}

export function treatmentPlanItemNetCentavos(item) {
  const gross = Number(item?.fee_centavos || item?.committed_fee_centavos || 0);
  if (item?.discount_pct != null && Number(item.discount_pct) > 0) {
    return Math.max(0, Math.round(gross * (1 - Number(item.discount_pct) / 100)));
  }
  if (item?.discount_amount_centavos != null && Number(item.discount_amount_centavos) > 0) {
    return Math.max(0, gross - Number(item.discount_amount_centavos));
  }
  return gross;
}

export function treatmentPlanVisitFeeDisplay(item, {
  currency = "PHP",
  isStageEntry = false,
  isFinalStageEntry = null,
  hasStages = null,
} = {}) {
  const net = treatmentPlanItemNetCentavos(item);
  const inferredHasStages = Array.isArray(item?.procedure_visits) && item.procedure_visits.length >= 2;
  const multiStage = hasStages == null ? inferredHasStages : Boolean(hasStages);
  const caseTotal = formatTreatmentPlanMoney(net, currency);
  const finalKnown = isFinalStageEntry !== null && isFinalStageEntry !== undefined;

  if (!isStageEntry) {
    return {
      value: caseTotal,
      label: multiStage ? "case total" : "patient fee",
      muted: false,
      kind: multiStage ? "case_total" : "patient_fee",
      caseTotalCentavos: net,
      isCaseFee: multiStage,
    };
  }

  if (net <= 0) {
    return {
      value: "No fee",
      label: "clinical step",
      muted: true,
      kind: "no_fee",
      caseTotalCentavos: 0,
      isCaseFee: false,
    };
  }

  if (multiStage && finalKnown && !isFinalStageEntry) {
    return {
      value: "Included",
      label: `${caseTotal} case total`,
      muted: true,
      kind: "included",
      caseTotalCentavos: net,
      isCaseFee: true,
    };
  }

  return {
    value: caseTotal,
    label: multiStage ? "case total" : "patient fee",
    muted: false,
    kind: multiStage ? "case_total" : "patient_fee",
    caseTotalCentavos: net,
    isCaseFee: multiStage,
  };
}

export function treatmentPlanVisitFeeDisplayForVisit(item, visit, options = {}) {
  const visits = Array.isArray(item?.procedure_visits) ? [...item.procedure_visits] : [];
  const sorted = visits.sort((a, b) => (Number(a?.sequence) || 0) - (Number(b?.sequence) || 0));
  const finalSeq = sorted.length > 0 ? Number(sorted[sorted.length - 1]?.sequence || 0) : Number(visit?.sequence || 1);
  const hasStages = sorted.length >= 2;
  const isStageEntry = hasStages || !!visit?.template_label || Number(visit?.sequence || 1) > 1;
  return treatmentPlanVisitFeeDisplay(item, {
    ...options,
    isStageEntry,
    hasStages,
    isFinalStageEntry: isStageEntry ? Number(visit?.sequence || 0) === finalSeq : null,
  });
}
